import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AdminNavComponent } from './nav.component';

@NgModule({
  declarations: [AdminNavComponent],
  imports: [CommonModule, RouterModule, MatIconModule, MatTooltipModule],
  exports: [AdminNavComponent],
})
export class AdminNavModule {}
